webpackJsonp([0],{

/***/ "./pages/template-documentation-page.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__("./node_modules/lodash/get.js");
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocsPage = function (_React$Component) {
	  _inherits(DocsPage, _React$Component);
	
	  function DocsPage() {
	    _classCallCheck(this, DocsPage);
	
	    return _possibleConstructorReturn(this, (DocsPage.__proto__ || Object.getPrototypeOf(DocsPage)).apply(this, arguments));
	  }
	
	  _createClass(DocsPage, [{
	    key: 'render',
	    value: function render() {
	      var post = this.props.data.markdownRemark;
	      return Glamor.createElement(
	        'div',
	        null,
	        Glamor.createElement(_reactHelmet2.default, {
	          title: post.frontmatter.title,
	          meta: [{
	            name: 'description',
	            content: post.excerpt
	          }]
	        }),
	        Glamor.createElement(
	          'h1',
	          null,
	          post.frontmatter.title
	        ),
	        Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } }),
	        Glamor.createElement('hr', null)
	      );
	    }
	  }]);
	
	  return DocsPage;
	}(_react2.default.Component);
	
	exports.default = DocsPage;
	var pageQuery = exports.pageQuery = '\n  query TemplatePage($fileSlug: String!) {\n    markdownRemark(fileSlug: { eq: $fileSlug }) {\n      html\n      excerpt\n      frontmatter {\n        title\n        prev: previous___FILE {\n          fileSlug\n          children {\n            ... on MarkdownRemark {\n              frontmatter {\n                title\n              }\n            }\n          }\n        }\n        next: next___FILE {\n          fileSlug\n          children {\n            ... on MarkdownRemark {\n              frontmatter {\n                title\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }

});


// WEBPACK FOOTER //
// page-component---pages-template-documentation-page-js-6f5bf6ea3c3e7f3dce16.js